import { SearchWithFilter } from 'components/search'

const AnatomiskPage = () => {
	return <SearchWithFilter />
}

export default AnatomiskPage
